(function() {
    'use strict';
    /**
     * @memberof app
     *@ngdoc service
     *@name UserService
     *@description
     *Servicio de autores
     */

    angular
        .module('app')
        .factory('PresupuestoService', PresupuestoService);

    PresupuestoService.$inject = ["$http","$window","$location"];

    function PresupuestoService($http,$window,$location){  

        var sesion = {
            Presupuestoform:Presupuestoform,
            Precios:Precios,
            SaveImagen
        };

        function Presupuestoform(vm) {
            var config = {
                headers: {
                }
            }

            return $http.post('/ajax/realizarpres', {
                presupuesto: JSON.stringify(vm.presupuesto),
                 //quitar  parametreos abajo para que al editar presupeusto 
                presupuesto_id:vm.presupuesto_id,
                changeform:vm.changeform,
                lang_id:lang_id,
            }, config)

                .then(function (data) {
                    return data.data;
                }, function (data) {
                    return data;
                });
        };

        function Precios(vm) {
            var config = { headers: {} }

            return $http.get('/ajax/getprecios', {
                params: { lang_id: lang_id, filtros: JSON.stringify(vm.filtros), }
            }, config)
                .then(function (data) {
                    return data.data;
                }, function (data) {
                    return data;
                });
        };

        function SaveImagen(vm) {
            var config = {
                headers: {
                }
            }

            return $http.post('/ajax/guardarimagen', {
               
                presupuesto_id:vm.presupuesto_id,
                file_print: vm.file_print,
                lang_id:lang_id,
            }, config)

                .then(function (data) {
                    return data.data;
                }, function (data) {
                    return data;
                });
        };

      return sesion;
    }
})();

